import React from 'react';
import PropTypes from 'prop-types';
import { Header, Segment } from 'semantic-ui-react';

import OtkupProdajaContent from './OtkupProdajaContent';
import enums from '../../../utils/Enums';
import localization from '../../../locales/localization';

export default class PredracunRacunContent extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Segment>
                    <Header as="h3">{localization.dnevnaEvidencija.predracun}</Header>
                    <OtkupProdajaContent
                        klijent={this.props.predracun.klijent}
                        type={enums.tipTabliceArtikala.RACUN_FIXED}
                        artikli={this.props.predracun.stavkePredracuna.map(si => {
                            return Object.assign({}, si, {
                                sifra: si.sifraArtikla,
                                naziv: si.nazivArtikla,
                                cijena: si.jedCijena
                            });
                        })}
                    />
                </Segment>
                <Segment>
                    <Header as="h3">{localization.dnevnaEvidencija.racun}</Header>
                    <OtkupProdajaContent
                        klijent={this.props.racun.klijent}
                        type={enums.tipTabliceArtikala.RACUN_FIXED}
                        artikli={this.props.racun.skladisniIzlazi.map(si => {
                            return Object.assign({}, si, {
                                sifra: si.sifraArtikla,
                                naziv: si.nazivArtikla,
                                cijena: si.jedCijena,
                                kolicina: this.props.racun.rbrStorniranogRacuna === null ? si.kolicina : -si.kolicina
                            });
                        })}
                    />
                </Segment>
            </React.Fragment>
        );
    }
}

PredracunRacunContent.propTypes = {
    predracun: PropTypes.object.isRequired,
    racun: PropTypes.object.isRequired
};
